import { useCallback, useContext } from 'react';
import useQueryParams from 'hooks/useQueryParams';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { Lead } from 'models/Lead';
import { LEAD_BACKGROUND_COLORS } from '../utils';
import { isDateFromLastDays } from 'utils';

export default function useLead() {
  const {
    currentUser: { _id: currentUserId },
  } = useContext(CurrentUserContext);

  const {
    params: { highlightLeadId },
  } = useQueryParams();

  const getIsNew = useCallback(
    ({ createdAt, brokerViewIds }: Lead) => {
      const inTheLast24Hours = isDateFromLastDays(createdAt, 1);
      const hasSeen = brokerViewIds?.includes(currentUserId);

      return !hasSeen && inTheLast24Hours;
    },
    [currentUserId],
  );

  const getBackgroundColor = useCallback(
    (lead: Lead) => {
      const { _id } = lead || {};

      if (highlightLeadId === _id) return LEAD_BACKGROUND_COLORS.CREAM;

      if (getIsNew(lead)) return LEAD_BACKGROUND_COLORS.GREEN;

      return LEAD_BACKGROUND_COLORS.DEFAULT;
    },
    [highlightLeadId, getIsNew],
  );

  return { getIsNew, getBackgroundColor };
}
